<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
  highlightedId: {
    type: Number,
    required: false,
    default: null,
  },
  nameOf: {
    type: Function,
    required: false,
    default: item => item.name,
  },
  lockReason: {
    type: Function,
    required: false,
    default: () => null,
  },
  availableLabel: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['open', 'toggle-available'])
</script>
<template>
  <div class="template-card-grid">
    <q-card
      v-for="item in items"
      :key="item.id"
      flat
      bordered
      class="template-card column"
      :class="{ 'row-highlight': item.id === highlightedId, 'is-hidden': !item.is_available }"
    >
      <div class="template-card-badges column q-gutter-xs">
        <slot name="badges" :item="item" />
      </div>
      <div class="template-card-paper cursor-pointer" @click="emit('open', item)">
        <slot name="paper" :item="item" />
      </div>
      <q-card-section class="q-pa-sm">
        <div class="row items-center no-wrap">
          <div class="col ellipsis text-weight-medium">{{ nameOf(item) }}</div>
          <q-btn
            flat
            round
            dense
            icon="mdi-dots-vertical"
          >
            <q-menu auto-close>
              <q-list dense>
                <slot name="menu" :item="item" />
              </q-list>
            </q-menu>
          </q-btn>
        </div>
        <div class="text-caption text-grey-7">
          <slot name="caption" :item="item" />
        </div>
        <div>
          <q-toggle
            :model-value="item.is_available"
            :label="availableLabel"
            :disable="!!lockReason(item)"
            dense
            @update:model-value="value => emit('toggle-available', item, value)"
          />
          <q-tooltip v-if="lockReason(item)">{{ lockReason(item) }}</q-tooltip>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<style scoped lang="scss">
.template-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  align-content: start;
  gap: 1rem;
}

.template-card {
  position: relative;
}

.template-card-badges {
  position: absolute;
  top: .5rem;
  left: .5rem;
  z-index: 1;
}

.template-card-paper {
  height: 10.5rem;
  overflow: hidden;
  padding: .75rem .875rem 0;
  background-color: $grey-3;
}

.template-card.is-hidden .template-card-paper {
  opacity: .5;
  filter: grayscale(.8);
}
</style>
